/**
 * O QueryClient num módulo próprio (CERES-008).
 *
 * Antes ele nascia dentro de `main.tsx` e só o provider o conhecia. A troca de
 * organização precisa LIMPAR o cache inteiro — dado da organização anterior em
 * tela ou em cache depois da troca é vazamento visual de tenant — e a sessão
 * não é componente filho do provider para usar `useQueryClient()`.
 */

import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Dado comercial muda com frequência: revalidar ao voltar à aba mantém o
      // pipeline coerente entre usuários sem inundar a API.
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Não insistir em erro do cliente: 401/403/404/409/422 não melhoram com
        // nova tentativa.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
